import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import qs from "query-string";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MainPageComponent from "./main.page";
import AccessRights from "../../../../configs/constants/accessRights";

function MainPageContainer() {
  const [activeIndex, setActiveIndex] = useState(null);
  const [disbursementActiveIndex, setDisbursementActiveIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.tab || "";
  const currentSummary = qsParams.summary || "";

  const canView = useSelector((state) =>
    state.session.accessRights.includes(
      AccessRights.COMPANY_CONSUMER_ENGAGEMENT_VIEW
    )
  );

    const canViewNotificationSettings = useSelector((state) =>
    state.session.accessRights.includes(
      AccessRights.COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_NOTIFICATION_EDIT
    )
  );

  useEffect(() => {
    if (!canView) {
      navigate("/admin");
    }
  }, [canView]);

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSummary) {
      case "companies":
        tempIndex = 0;
        break;
      case "transaction-reports":
        tempIndex = 1;
        break;
      case "notification-settings":
        tempIndex = canViewNotificationSettings ? 2 : 0;
        break;
      default:
        tempIndex = 0;
    }
    setDisbursementActiveIndex(tempIndex);
  }, [currentSummary, canViewNotificationSettings]);

  useEffect(() => {
  if (currentSummary === "notification-settings" && !canViewNotificationSettings) {
    navigate(`/admin/consumer-engagement?tab=disbursements&summary=companies`, { replace: true });
  }
}, [currentSummary, canViewNotificationSettings, navigate]);

  useEffect(() => {
    setActiveIndex(0);
  }, [currentSearch]);

  const tabLabels = ["Disbursements"];

  const disbursementHandleChange = (event, index) => {
    setDisbursementActiveIndex(index);
    const tabRoutes = {
      0: "companies",
      1: "transaction-reports",
      ...(canViewNotificationSettings && { 2: "notification-settings" }),
    };
    navigate(
      `/admin/consumer-engagement?tab=disbursements&summary=${tabRoutes[index]}`
    );
  };

  const handleChange = (event, index) => {
    setActiveIndex(index);
    navigate(`/admin/consumer-engagement?tab=disbursement`);
  };

  return (
    <>
      <MainPageComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
        disbursementActiveIndex={disbursementActiveIndex}
        disbursementHandleChange={disbursementHandleChange}
        canViewNotificationSettings={canViewNotificationSettings}
      />
    </>
  );
}

export default MainPageContainer;
